const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

function openCartDrawer() {
	document.querySelector(".cart-drawer").classList.add("active");
}
function closeCartDrawer() {
	document.querySelector(".cart-drawer").classList.remove("active");
}
async function updateCartDrawer() {
	let res = await fetch("/?section_id=cart-drawer");
	let text = await res.text();
	let html = document.createElement("div");
	html.innerHTML = text;
	let newCart = html.querySelector(".inset .cart-container").innerHTML;
	let oldCart = document.querySelector(".cart-drawer .cart-container");
	oldCart.innerHTML = newCart;
	addCartDrawerListeners();
}
function updateCartItemCounts(count) {
	//Update Cart Count
	document.querySelectorAll(".cart-count-bubble").forEach((el) => {
		el.textContent = count;
	});
}
function addCartDrawerListeners() {
	// Close the Drawer
	document.querySelectorAll(".cart-drawer, .close-cart-drawer").forEach((el) => {
		el.addEventListener("click", () => {
			closeCartDrawer();
		});
	});

	// Dont' Close Drawer when click the 'form'
	let cartDrawerInset = document.querySelector(".cart-drawer .cart-drawer-sidebar");
	if (cartDrawerInset) {
		cartDrawerInset.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}

	//Update Cart Quantities
	document.querySelectorAll(".quantity-box-wrapper button").forEach((button) => {
		button.addEventListener("click", async () => {
			//Get Line Item Key
			const itemKey = button.parentElement.parentElement.parentElement.getAttribute("data-line-item-key");
			//Get Current Quantity
			let currentQuantity = Number(button.parentElement.querySelector("input").value);
			let increase = button.getAttribute("name") == "plus" ? true : false;
			let newQuantity = increase ? currentQuantity + 1 : currentQuantity - 1;

			let res = await fetch("/cart/update.js", {
				method: "post",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					updates: { [itemKey]: newQuantity },
				}),
			});
			let cart = await res.json();
			updateCartItemCounts(cart.item_count);

			//Update Cart
			updateCartDrawer();
		});
	});
}
addCartDrawerListeners();

addToCartForms.forEach((form) => {
	form.addEventListener("submit", async (event) => {
		event.preventDefault();

		//Submit to Ajax
		await fetch("/cart/add", {
			method: "post",
			body: new FormData(form),
		});

		// Get New Cart Object

		let res = await fetch("/cart.json");
		let cart = await res.json();

		//Display message
		const message = document.createElement("div");
		message.classList.add("added-to-cart-message");
		message.textContent = "Added to Cart!";
		form.appendChild(message);

		//Update Cart
		await updateCartDrawer();
		updateCartItemCounts(cart.item_count);
		addCartDrawerListeners();
		openCartDrawer();
	});
});

//All carts links open drawer
document.querySelectorAll('a[href="/cart"').forEach((a) => {
	a.addEventListener("click", (e) => {
		e.preventDefault();
		openCartDrawer();
	});
});
